<template>
<div class="container is-fluid">
  <div class="banner">
    <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
  </div><br>
  <section>
    <div class="container">
    <h1 class="title">
        BP Estimate (สาขา {{ branchSelected }})
    </h1>
    </div>
  </section>
  <div class="columns" v-if="!updateJob">
    <div class="column is-1" style="background-color:#fff;">
      <button class="button is-link" @click="add">รับรถใหม่</button>
    </div>
  </div>

  <div class="columns colFixed" v-if="showMenu">
    <div class="column is-3 "><span class="menuFixed">ใบเคลมรอประเมิน ({{carList['start'].length}})</span></div>
    <div class="column is-3 "><span class="menuFixed">รอประกันอนุมัติ ({{carList['waitInsurance'].length}})</span></div>
    <div class="column is-3 "><span class="menuFixed">รอรถลูกค้า ({{carList['waitCustomer'].length}})</span></div>
    <div class="column is-3 "><span class="menuFixed">รอคิวซ่อม ({{carList['queueWorkshop'].length}})</span></div>
  </div>

  <div class="columns allFrame bodyFrame" v-if="!updateJob">
    <div class="column is-3">
      <h3>ใบเคลมรอประเมิน ({{carList['start'].length}})</h3>
      <draggable class="list-group" tag="ul" v-model="carList['start']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group type="transition" id="start">
          <li class="list-group-item" v-for="element in carList['start']" :key="element.id">
            <card group="1" :item="element" page="estimate" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-3">
      <h3>รอประกันอนุมัติ ({{carList['waitInsurance'].length}})</h3>
      <draggable element="span" v-model="carList['waitInsurance']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="waitInsurance">
          <li class="list-group-item" v-for="element in carList['waitInsurance']" :key="element.id">
            <card group="1" :item="element" page="estimate" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-3">
      <h3>รอรถลูกค้า ({{carList['waitCustomer'].length}})</h3>
      <draggable element="span" v-model="carList['waitCustomer']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="waitCustomer">
          <li class="list-group-item" v-for="element in carList['waitCustomer']" :key="element.id">
            <card group="1" :item="element" page="estimate" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-3">
      <h3>รอคิวซ่อม ({{carList['queueWorkshop'].length}})</h3>
      <draggable element="span" v-model="carList['queueWorkshop']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="queueWorkshop">
          <li class="list-group-item" v-for="element in carList['queueWorkshop']" :key="element.id">
            <card group="1" :item="element" page="estimate" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

  </div>

  <section class="section" v-if="updateJob">
    <div class="container">
      <div class="columns">
        <div class="column is-4 is-form">
          <h2 class="title is-4">กรุณากรอกข้อมูลเพิ่มเติม<br>สำหรับรถหมายเลขทะเบียน {{ target.licenseNo }} </h2>
          <div class="field">
            <label class="label">เลขที่ Job ZR-13</label>
            <div class="control">
              <input class="input" type="text" placeholder="เลขที่ job ZR-13" v-model="carInfo.runNo">
            </div>
          </div>
          <div class="field">
            <label class="label">ประเภทงาน</label>
            <div class="select">
              <select v-model="carInfo.jobType">
                <option v-for="jobType in jobTypeList" v-bind:key="jobType.code" :value="jobType.code" >{{ jobType.name }}</option>
              </select>
            </div>
          </div>
          <div class="field">
            <label class="label">วันที่นัดลูกค้า</label>
            <div class="control">
              <input class="input" type="text" placeholder="วันที่นัดลูกค้า" v-model="carInfo.expectedDate"><br>
              <span class="note">DD/MM/2020</span>
            </div>
          </div>
          <div class="field">
            <label class="label">วันที่นัดช่าง</label>
            <div class="control">
              <input class="input" type="text" placeholder="วันที่นัดช่าง" v-model="carInfo.trackDate"><br>
              <span class="note">DD/MM/2020</span>
            </div>
          </div>
          <br>
          <button class="button is-success" v-on:click="updateJobsInfo">{{ btn_action }}</button>
        </div>
      </div>
    </div>
  </section>

</div>
</template>

<script>
import draggable from 'vuedraggable'
import card from './card.vue'
export default {
  name: 'hello',
  components: {
    draggable,
    'card': card
  },
  data: () => ({
    branchCode: '',
    updatedBy: null,
    branch: [],
    jobTypeList: [
      { 'code': 'Q', 'name': 'Q' },
      { 'code': 'M', 'name': 'M' },
      { 'code': 'H', 'name': 'H' },
      { 'code': 'S', 'name': 'Super Quick' }
    ],
    dataAlready: {
      'start': false,
      'waitInsurance': false,
      'waitCustomer': false,
      'queueWorkshop': false
    },
    carId: '',
    carList: {
      'start': [],
      'waitInsurance': [],
      'waitCustomer': [],
      'queueWorkshop': []
    },
    caption: {
      'start': 'ใบเคลมรอประเมิน',
      'waitInsurance': 'รอประกันอนุมัติ',
      'waitCustomer': 'รอรถลูกค้า',
      'queueWorkshop': 'รอคิวซ่อม'
    },
    editable: true,
    isDragging: false,
    delayedDragging: false,
    target: {
      licenseNo: ''
    },
    fromId: null,
    toId: null,
    updateJob: false,
    carInfo: {
      runNo: '',
      expectedDate: '',
      jobType: '',
      trackDate: ''
    },
    btn_action: 'Submit',
    showMenu: false,
    branchSelected: null,
    profile: null
  }),
  async mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    this.updatedBy = this.$session.get('vgroup')
    this.branch = this.$branchList
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    this.branchCode = params.get('branchCode')
    this.branch.map((item) => {
      this.branchSelected = (item.id === this.branchCode) ? item.name : this.branchSelected
      return true
    })
    await this.getProfile()
    this.getList()
    this.autoReload()
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getList () {
      this.getCarList('start')
      this.getCarList('waitInsurance')
      this.getCarList('waitCustomer')
      this.getCarList('queueWorkshop')
    },
    async getProfile () {
      await this.$axios
        .get(`${this.$apiUrl}getStaffById?code=${this.updatedBy}`)
        .then(response => {
          if (response.data.length > 0) {
            this.profile = response.data[0]
          }
        })
    },
    handleScroll (event) {
      if (event.path[1].scrollY >= 250) {
        this.showMenu = true
      } else {
        this.showMenu = false
      }
    },
    autoReload () {
      let _this = this
      _this.t = setInterval(() => {
        this.getList()
      }, 120 * 1000)
    },
    stopReload () {
      clearInterval(this.t)
    },
    add () {
      window.open('/RegisterBP?branchCode=' + this.branchCode)
    },
    getCarList (step) {
      let _this = this
      _this.dataAlready[step] = false
      this.$axios
        .get(`${this.$apiUrl}getCarProgressBP?current=${step}&branch=${_this.branchCode}`)
        .then(response => {
          _this.dataAlready[step] = true
          _this.carList[step] = response.data
        })
    },
    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      this.target = draggedElement
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    async onEnd (/** Event */ evt) {
      this.fromId = evt.from.id
      this.toId = evt.to.id
      const msg = `ต้องการเปลี่ยนสถานะงาน ${this.target.licenseNo} เป็น ${this.caption[this.toId]}`
      if (confirm(msg)) {
        if (this.toId === 'queueWorkshop') {
          this.updateJob = true
        } else {
          this.updateJob = false
        }
        await this.updateProgress()
      } else {
        this.carList[this.fromId].push(this.target)
        this.carList[this.toId].pop()
      }
    },
    async updateProgress () {
      this.stopReload()
      let params = {
        car: this.target,
        carId: this.target.id,
        current: this.fromId,
        nextStep: this.toId,
        staffId: null,
        staffId_2: null
      }
      await this.$axios
        .post(`${this.$apiUrl}updateProgressBP`, params)
        .then(response => {
          this.updateSuccess = true
          this.getList()
          this.autoReload()
        })
    },
    async updateJobsInfo () {
      this.stopReload()
      this.btn_action = 'Loading...'
      let params = {
        carId: this.target.id,
        runNo: this.carInfo.runNo,
        expectedDate: this.carInfo.expectedDate,
        jobType: this.carInfo.jobType,
        trackDate: this.carInfo.trackDate,
        unCloseReason: ''
      }
      await this.$axios
        .post(`${this.$apiUrl}updateBPInfo`, params)
        .then(response => {
          this.updateSuccess = true
          this.updateJob = false
          this.btn_action = 'Submit'
          this.carInfo = {
            runNo: '',
            expectedDate: '',
            jobType: '',
            trackDate: '',
            unCloseReason: ''
          }

          this.getList()
          this.autoReload()
        })
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      }
    },
    listString () {
      return JSON.stringify(this.list, null, 2)
    },
    list2String () {
      return JSON.stringify(this.list2, null, 2)
    }
  },
  watch: {
    isDragging (newValue) {
      if (newValue) {
        console.log(this.draggedElement)
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    }
  }
}
</script>

<style scoped>
#queueWorkshop {
  min-height: 2000px;
}
.colFixed {
  position: fixed;
  top: 10px;
  z-index: 9;
  width: 100%;
}
.colFixed > div.column {
  margin: 3px;
  background-color: #ccc !important;
}
.menuFixed {
  font-size: 16px;
  font-weight: bold;
}
.bodyFrame {
  padding-top: 50px;
}
.headFrame {
  position: fixed;
}
.note {
  padding-left: 10px;
  color: #666;
  font-size: 13px;
}
.allFrame {
  width: 99.8%;
}
.banner {
  text-align: center;
  background-color: #000;
}
.is-form {
  margin-left: 30% !important;
}
h3 {
  font-size: 18px;
  font-weight: bold;
}
.container {
  margin: 0 auto;
}
.column {
  margin: 3px;
  background-color: #eee;
}
.is-1 {
  width: 11.65%;
}
.item-queue {
  float: left;
  width: 45%;
  margin-left: 10px;
}
.item-wait {
  float: left;
  width: 30%;
  margin-left: 10px;
}
.flip-list-move {
  transition: transform .5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  background: #c8ebfb;
  opacity: .5;
}
.list-group {
  min-height: 350px;
  padding-bottom: 20px;
  background-color: #eee;
}
.list-group-item {
  height: 85px;
  padding: 15px 8px;
  margin-top: 5px;
  background-color: #ccc;
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BP/estimate.vue